import React from "react";
import { graphql } from '@apollo/client/react/hoc';
import { gql } from "@apollo/client";
import { Loading } from "@website2018/da-dobsonville";
import { Redirect } from "react-router-dom";

import MetaHeader from '../../components/Meta/MetaHeader';
import GNUTemplate from "../../components/Page/GNUTemplate";

class GNUContainer extends React.Component {
  render() {
    const { error, loading, page: p } = this.props;

    if (loading) return <Loading />;
    if (error || !p) return <Redirect to={"/not-found"} />;

    return [<MetaHeader p={p} />, <GNUTemplate {...this.props} />];
  }
}

const GNU_QUERY = gql`
  query getGnuPage {
    page(slug: "the-gnu") {
      id
      slug
      seo
      template
      acf
      title {
        rendered
      }
      content {
        rendered
      }
      excerpt {
        rendered
      }
      featured_media {
        id
        source_url
        title {
          rendered
        }
      }
      hero {
        headline
        description
        cta_type
        cta_group {
          title
          link_label
          link_url
        }
        background_image {
          url
        }
        focus_point
        countdown {
          headline
          date
        }
      }
      asides {
        id
        title {
          rendered
        }
        content {
          rendered
        }
        aside_options
      }
      asides_grid {
        id
        title {
          rendered
        }
        content {
          rendered
        }
        aside_options
      }
    }
    portfolios {
      id
      slug
      seo
      acf
      content {
          rendered
      }
      title {
          rendered
      }
    }
  }
`;

const withGnu = graphql(GNU_QUERY, {
  options: props => {
    return {
      variables: {
        slug: props.match.params.slug
      }
    };
  },
  props: ({ data }) => ({ ...data })
});

GNUContainer = withGnu(GNUContainer);

export default GNUContainer;
